export default __webpack_public_path__ + "static/media/snow.005a5b8d.jpg";